import type { SVGProps } from 'react';

/**
 * Schubladen-/Folder-Stack — drei gestapelte Karten, oberste gefuellt.
 * Symbolisiert "leerer Katalog, fuelle ihn mit Datasets".
 */
export function EmptyCatalogIllustration(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect
        x="22"
        y="34"
        width="84"
        height="14"
        rx="3"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.35"
      />
      <rect
        x="22"
        y="54"
        width="84"
        height="14"
        rx="3"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.55"
      />
      <rect
        x="22"
        y="74"
        width="84"
        height="22"
        rx="4"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="currentColor"
        fillOpacity="0.10"
      />
      <line
        x1="32"
        y1="82"
        x2="68"
        y2="82"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.7"
      />
      <line
        x1="32"
        y1="88"
        x2="56"
        y2="88"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.4"
      />
    </svg>
  );
}
